import { dashIfEmpty } from "../../../constants/utils";
import type { ServiceLevel } from "../../../services/prePlanningService.types";

export const formatTrailerTitle = (
  name?: string | null,
  title?: string | null
) =>
  dashIfEmpty(
    name ? name + (title && name !== title ? " " + title : "") : title ?? ""
  );

export const isMexicoLTLService = (
  isMexicoTooltipEnabled: boolean,
  serviceLevel?: ServiceLevel | null
): boolean => serviceLevel === "MXUS-LTL" && isMexicoTooltipEnabled;
